import { SET_EQUIPMENT } from '../actions/types';

export default function equipment(state = null, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_EQUIPMENT:
				return action.payload;

			// no default
		}
	}

	return state;
}
